import React from 'react';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import CloudQueueOutlinedIcon from '@mui/icons-material/CloudQueueOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import AdjustIcon from '@mui/icons-material/Adjust';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import africaImg from '../assets/africa.png';

const WhyChooseUs = () => {
  return (
    <>
      <section className="section mission-section">
        <img src={africaImg} alt="Africa Map" className="africa-bg-img" />
        <div className="container">
          <div className="mission-grid">
            <div className="mission-header">
              <h2>Technology That Solves<br/>Real Business Problems</h2>
              <div className="divider-short"></div>
            </div>
            <div className="mission-statements">
              <div className="mission-statement">
                <div className="mission-statement-icon">
                  <AdjustIcon fontSize="large" />
                </div>
                <div>
                  <h4 className="text-primary">Mission</h4>
                  <p>Redefining the digital age through technology that empowers.</p>
                </div>
              </div>
              <div className="mission-statement">
                <div className="mission-statement-icon">
                  <RemoveRedEyeOutlinedIcon fontSize="large" />
                </div>
                <div>
                  <h4 className="text-primary">Vision</h4>
                  <p>To become a recognized leader in delivering innovative, reliable, and scalable technology solutions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section features-section">
        <div className="container">
          <div className="text-center mb-8">
            <h2 style={{ color: 'var(--color-bg)' }}>Why Choose Us</h2>
          </div>

          <div className="why-choose-us-grid">
            <div className="feature-card">
              <div className="icon-wrapper"><RocketLaunchOutlinedIcon /></div>
              <h4>End-to-End Delivery</h4>
              <p>From concept to deployment and support.</p>
            </div>
            <div className="feature-card">
              <div className="icon-wrapper"><CloudQueueOutlinedIcon /></div>
              <h4>Scalable Architecture</h4>
              <p>Built for growth using modern cloud technologies.</p>
            </div>
            <div className="feature-card">
              <div className="icon-wrapper"><ExtensionOutlinedIcon /></div>
              <h4>Problem-Driven Approach</h4>
              <p>We focus on solving real business challenges.</p>
            </div>
            <div className="feature-card">
              <div className="icon-wrapper"><SecurityOutlinedIcon /></div>
              <h4>Experience in Secure Systems</h4>
              <p>Including identity verification and data-sensitive platforms.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;
